const ko = {
  ID_STUDIO_NEW_PROJECT_POPUP_TITLE: "새 프로젝트 만들기",
  ID_STUDIO_NEW_PROJECT_POPUP_SELECT_TECH_LANGUAGE: "개발 언어 선택",
  ID_STUDIO_NEW_PROJECT_POPUP_TEXT_CODING: "텍스트코딩",
  ID_STUDIO_NEW_PROJECT_POPUP_BLOCK_CODING: "블록코딩",

  ID_STUDIO_NEW_PROJECT_POPUP_PROJECT_NAME: "프로젝트 명",
  ID_STUDIO_NEW_PROJECT_POPUP_PROJECT_NAME_INPUT_PLACEHOLDER: "프로젝트명을 입력해주세요.",

  ID_STUDIO_NEW_PROJECT_POPUP_STAR_BTN: "시작하기",

  ID_STUDIO_LIST_TITLE: "Studio",
  ID_STUDIO_CREATE_LIST_TITLE: "새로 만들기",
  ID_STUDIO_CREATE_WORLD_BTN: "3D World",
  ID_STUDIO_MY_PROJECT_TITLE: "나의 프로젝트",
  ID_STUDIO_PUBLISHED_APP_TITLE: "퍼블리싱 앱",

  ID_STUDIO_OOBC_LABEL: "OOBC",
  ID_STUDIO_JS_LABEL: "JS",

  ID_STUDIO_LIST_MORE_VIEW: "전체보기 ",
  ID_STUDIO_LIST_PUBLIC: "공개",
  ID_STUDIO_LIST_DROP_EDIT: "수정",
  ID_STUDIO_LIST_DROP_DELETE: "삭제",
  ID_STUDIO_LIST_DROP_COPY: "복사",

  ID_SUTDIO_EDIT_CONTENT_TITLE: "콘텐츠 수정",
  ID_STUDIO_EDIT_CONTENT_CATEGORY_NAME: "콘텐츠 이름",
  ID_STUDIO_EDIT_CONTENT_CATEGORY_EXPLAIN: "콘텐츠 설명",
  ID_STUDIO_EDIT_IMAGE_NOTICE_TEXT: "*대표 이미지를 등록하지\n않으시면 자동으로 등록됩니다.",
  ID_STUDIO_EDIT_CHANGE_IMAGE_BUTTON: "이미지 변경",
  ID_STUDIO_EDIT_CANCEL_BUTTON: "취소",
  ID_STUDIO_EDIT_CONTENT_NAME_PLACEHOLDER: "콘텐츠 이름을 입력해주세요.",
  ID_STUDIO_EDIT_CONTENT_TEXTAREA_PLACEHOLDER: "콘텐츠 설명을 입력해주세요.",

  ID_STUDIO_PROJECT_DELETE_CONFIRM_MESSAGE: "프로젝트를 삭제할까요?",
  ID_STUDIO_PUBLISHED_DELETE_CONFIRM_MESSAGE: "퍼블리싱 앱을 삭제할까요?",

  // Tooltip
  ID_STUDIO_TOOLTIP_UNDO_BTN_DESC: "Undo",
  ID_STUDIO_TOOLTIP_UNDO_BTN_SHORTCUT: "Ctrl + Z",
  ID_STUDIO_TOOLTIP_REDO_BTN_DESC: "Redo",
  ID_STUDIO_TOOLTIP_REDO_BTN_SHORTCUT: "Ctrl + Shift + Z",
  ID_STUDIO_TOOLTIP_POSITION_BTN_DESC: "Position",
  ID_STUDIO_TOOLTIP_POSITION_BTN_SHORTCUT: "2",
  ID_STUDIO_TOOLTIP_ROTATION_BTN_DESC: "Rotation",
  ID_STUDIO_TOOLTIP_ROTATION_BTN_SHORTCUT: "3",
  ID_STUDIO_TOOLTIP_SCALE_BTN_DESC: "Scale",
  ID_STUDIO_TOOLTIP_SCALE_BTN_SHORTCUT: "4",
  ID_STUDIO_TOOLTIP_OBJECT_PANEL_OPEN: "Open Panel",
  ID_STUDIO_TOOLTIP_OBJECT_PANEL_CLOSE: "Fold Panel",
  ID_STUDIO_TOOLTIP_PROPERTY_PANEL_OPEN: "Open Panel",
  ID_STUDIO_TOOLTIP_PROPERTY_PANEL_CLOSE: "Fold Panel",
  ID_STUDIO_TOOLTIP_PLAY_BTN: "Play",
  ID_STUDIO_TOOLTIP_STOP_BTN: "Stop",
  ID_STUDIO_TOOLTIP_CODE_MODE_BTN: "Code Mode",
  ID_STUDIO_TOOLTIP_DELETE_BTN: "Delete",
};

export default ko;
